import React from 'react';
import { Row, Col, Checkbox, Modal, Form, Alert } from 'antd';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import { EXTEND_VIGNETTE_ROUTE } from 'constants/index';
import './styles.scss';
import StepCard from 'components/StepCard';
import { history } from 'util/helpers/history';

class FullPaymentInstruction extends React.Component {
  state = {
    showModal: false,
    visible: true,
  };

  componentDidMount() {
    history.location.state = {};
  }

  handleCancel = () => {
    this.setState({ showModal: false });
  };

  handleCheckBox = e => {
    this.setState({ checked: e.target.checked });
  };

  checkCheckBox = (rule, value, callback) => {
    if (!value) {
      callback(<FormattedMessage id="help.confirm.this" />);
    } else {
      callback();
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.updateRoute(EXTEND_VIGNETTE_ROUTE.PAYMENT_IDEAL);
      }
    });
  };
  renderModal = () => {
    return (
      <Modal
        visible={this.state.showModal}
        onCancel={this.handleCancel}
        footer={null}
        width={720}
      >
        <div className="modal-wrapper">
          <p className="modal-title">
            <FormattedMessage id="extend.step.payment.terms.condition" />
          </p>
          <p className="modal-instruction">
            <FormattedHTMLMessage id={this.state.message} />
          </p>
        </div>
      </Modal>
    );
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    setTimeout(() => {
      this.setState({ visible: false });
    }, 5000);
    return (
      <Form onSubmit={this.handleSubmit}>
        <StepCard
          steps={7}
          current={5}
          onPrevious={() =>
            this.props.updateRoute(EXTEND_VIGNETTE_ROUTE.PAYMENT_CHOICE)
          }
          onNext={this.handleSubmit}
          id="extend.step.personal.title"
          className="full-payment-screen"
        >
          {this.renderModal()}
          <Row>
            <div>
              <p className="title">
                <FormattedMessage id="extend.step.payment.choice.full" />
              </p>
            </div>
            <Col span={24} xs={24} lg={24} md={24} sm={24}>
              <p>
                <FormattedMessage id="extend.step.payment.full.instruction.one" />
              </p>
              <div className="payment-type-wrapper">
                <p>
                  <FormattedMessage id="extend.step.payment.full.instruction.two" />
                </p>
              </div>
              <div className="payment-type-wrapper">
                <Form.Item>
                  {getFieldDecorator('checkbox', {
                    valuePropName: 'checked',
                    rules: [{ validator: this.checkCheckBox }],
                  })(
                    <Checkbox>
                      <span>
                        <FormattedMessage id="extend.step.payment.info.agreement" />
                      </span>
                    </Checkbox>,
                  )}
                  {/* <a
                    onClick={() =>
                      this.setState({
                        showModal: true,
                        message: 'extend.step.terms.and.condition.message',
                      })
                    }
                  >
                    <FormattedMessage id="extend.step.terms.and.condition" />
                  </a>
                  ,&nbsp; */}
                  <a
                    href="https://decentrale.regelgeving.overheid.nl/cvdr/xhtmloutput/Actueel/Amsterdam/CVDR635093.html"
                    target="_blank"
                  >
                    <FormattedMessage id="extend.step.port.rules" />
                    &nbsp;
                  </a>
                  en{' '}
                  <a
                    href="https://decentrale.regelgeving.overheid.nl/cvdr/xhtmloutput/Historie/Amsterdam/73996/CVDR73996_9.html"
                    target="_blank"
                  >
                    VOB
                  </a>
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row type="flex" align="center">
            {this.props.mandateResponseMsg && this.state.visible && (
              <>
                <Alert
                  type="error"
                  message={
                    <FormattedMessage id={this.props.mandateResponseMsg} />
                  }
                />
              </>
            )}
          </Row>
        </StepCard>
      </Form>
    );
  }
}
const FullPaymentInstructionForm = Form.create({
  name: 'FullPaymentInstruction',
})(FullPaymentInstruction);
export default FullPaymentInstructionForm;
